import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { t, useLocale } from '../hooks/useT';
import { AdminTabs, type AdminTabId } from '../components/admin/AdminTabs';
import { AdminStatsTab } from '../components/admin/AdminStatsTab';
import { AdminUsersTab } from '../components/admin/AdminUsersTab';
import { AdminPuzzlesTab } from '../components/admin/AdminPuzzlesTab';

export function AdminPage() {
  const { user, loading } = useAuth();
  const { locale } = useLocale();
  const [tab, setTab] = useState<AdminTabId>('stats');

  if (loading) {
    return <main className="page admin"><p>{t('common.loading')}</p></main>;
  }

  if (!user) {
    return (
      <main className="page admin">
        <p>{t('admin.loginRequired')}</p>
        <Link to="/login" className="btn primary">{t('landing.login')}</Link>
      </main>
    );
  }

  if (!user.isAdmin) {
    return (
      <main className="page admin">
        <h1>{t('admin.title')}</h1>
        <p>{t('admin.forbidden')}</p>
        <Link to="/" className="btn secondary">{t('admin.backHome')}</Link>
      </main>
    );
  }

  return (
    <main className={`page admin admin-dashboard${tab === 'puzzles' ? ' admin-dashboard--wide' : ''}`} key={locale}>
      <div className="admin-dashboard-head">
        <h1>{t('admin.title')}</h1>
        <AdminTabs active={tab} onChange={setTab} />
      </div>
      <div className="admin-panel" role="tabpanel">
        {tab === 'stats' && <AdminStatsTab />}
        {tab === 'users' && <AdminUsersTab />}
        {tab === 'puzzles' && <AdminPuzzlesTab />}
      </div>
    </main>
  );
}
